export const MessagesConstant = {
  // tabKey: "activeTabKey",
  // defaultTabKey: 0,
  headerConfig: {
    title: "Communication Channel",
    id: "group",
  },
  chatList: [
    {
      id: 1,
      name: "Jane Doe",
      topic: "Pay Request",
      message: "Hi! I need help in submitting a request.",
      time: "3:45 am",
      status: "Pending",
      count: 3,
    },
    {
      id: 2,
      name: "Jane Doe",
      topic: "Contract Management",
      message: "Hi! I need help in submitting a request.",
      time: "3:45 am",
      status: "Pending",
      count: 0,
    },
    {
      id: 3,
      name: "Jane Doe",
      topic: "Contract Management",
      message: "Hi! I need help in submitting a request.",
      time: "3:45 am",
      status: "Resolved",
      count: 0,
    },
    {
      id: 4,
      name: "Jane Doe",
      topic: "Contract Management",
      message: "Hi! I need help in submitting a request.",
      time: "3:45 am",
      status: "Resolved",
      count: 0,
    },
  ],
  messages: [
    {
      id: 1,
      sender: "Provider",
      text: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipisicing Elit, Sed Do Eiusmod Tempor.",
      time: "10:12 AM",
      type: "incoming",
    },
    {
      id: 2,
      sender: "Admin",
      text: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipisicing Elit, Sed Do Eiusmod Tempor.",
      time: "10:10 AM",
      type: "outgoing",
    },
    {
      id: 3,
      sender: "Provider",
      text: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipisicing Elit, Sed Do Eiusmod Tempor.",
      time: "10:12 AM",
      type: "incoming",
    },
  ],
};
